import React, { useState } from "react";
import ShareIcon from "@assets/icons/team.svg?react";
import DragonIcon from "@assets/dragons/normal.svg?react";
import OpenIcon from "@assets/icons/files-history.svg?react";
import { PopoverContent } from "@shared/components/PopoverContent";
import { uiState } from "@shared/states/uiStates";
import { CollaborateOptions } from "@shared/Toolbar/CollaboratePopup/CollaboratePopup";
import { DragonOptions } from "@shared/Toolbar/DragonButton/DragonPopover";
import { NewToolbarButton } from "@shared/Toolbar/NewToolbarButton";
import { SaveImageToolButton } from "@shared/Toolbar/SaveImageToolButton";
import { StrategiesButton } from "@shared/Toolbar/StrategiesButton/StrategiesButton";

interface MobileActionsPopupProps {
	onClose: () => void;
}

export const MobileActionsPopup: React.FC<MobileActionsPopupProps> = (props) => {
	const [action, setAction] = useState<null | "dragon" | "collaborate">(null);

	return (
		<PopoverContent
			className={"flex flex-col gap-3 w-fit max-w-[92vw] max-h-[80vh] overflow-y-auto"}
		>
			{action === "dragon" && <DragonOptions onClose={props.onClose} />}
			{action === "collaborate" && <CollaborateOptions />}

			<div className={"flex flex-wrap items-center gap-1"}>
				<NewToolbarButton
					onClick={() => setAction(action === "dragon" ? null : "dragon")}
					isSelected={action === "dragon"}
					tooltipMessage={"Dragon / Baron"}
					testId={"mobile-dragon"}
				>
					<DragonIcon width={28} height={28} />
				</NewToolbarButton>
				<NewToolbarButton
					onClick={() => setAction(action === "collaborate" ? null : "collaborate")}
					isSelected={action === "collaborate"}
					tooltipMessage={"Share"}
					testId={"mobile-collaborate"}
				>
					<ShareIcon width={28} height={28} />
				</NewToolbarButton>
				<StrategiesButton />
				<SaveImageToolButton />
				<NewToolbarButton
					onClick={() => (uiState.modal = "import")}
					tooltipMessage={"Import game from history"}
					testId={"mobile-import"}
				>
					<OpenIcon width={28} height={28} />
				</NewToolbarButton>
			</div>
		</PopoverContent>
	);
};
